var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-card',{attrs:{"title":"История изменений"}},[_c('table-with-front-pagination-design',{staticClass:"approval-page-history__table",attrs:{"items":_vm.history,"headers":_vm.headers,"statuses":_vm.statuses,"time-data":_vm.timeData,"loading":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }